import { Attribute } from 'types';
import { Attribute as AttributeModel } from 'models';
import AttributeManager from '../AddManageAttribute/AddManageAttribute';
import CollapseCommon from 'components/common/Collapse/CollapseCommon';

interface Props {
  isEdit: boolean;
  isInactive?: boolean;
  attributes?: AttributeModel[];
  productAttributes: Attribute[];
  setProductAttributes: (val: Attribute[]) => void;
}

const ProductAttributeSection = ({
  isEdit,
  attributes,
  productAttributes,
  setProductAttributes,
  isInactive,
}: Props) => {
  return (
    <CollapseCommon collapseKey='4' title='Thuộc tính sản phẩm'>
      <AttributeManager
        isEdits={isInactive ? !isInactive : isEdit}
        attributes={attributes
          ?.filter((attribute) => attribute.type === 'product')
          ?.map((attribute) => ({
            name: attribute.name,
            value: attribute.id,
          }))}
        treeList={productAttributes}
        onTreeListChange={(items) => setProductAttributes(items as Attribute[])}
        placeholderTitle='Tên thuộc tính...'
        placeholderSurcharge='Giá tính thêm...'
        placeholderNote='Ghi chú của thuộc tính'
      />
    </CollapseCommon>
  );
};

export default ProductAttributeSection;
